import { useUiLayoutStore } from '~/store'
import { VideoState, VideoStateKey } from './symbols'
import { useWebOrNativeLocalStorage, STORAGE_KEYS } from '@/utils/storage'
import { useWebToApp } from '~/composable/native/index'
import { NATIVE_MATHOD, NATIVE_CALL_BACK } from '~/constants/native/index'
import { useUtilDetectAllStore } from '~/store/common/index'

export function useVideos() {
  const detectAllStore = useUtilDetectAllStore()
  const { isNativeApp } = storeToRefs(detectAllStore)

  const webOrNativeLocalStorage = useWebOrNativeLocalStorage()
  const { callBridgeNative } = useWebToApp()

  const uiLayoutStore = useUiLayoutStore()
  const videoState = inject(VideoStateKey) as VideoState
  const showVideo = () => {
    videoState.isShowVideo.value = true
  }
  const hideVideo = () => {
    videoState.isShowVideo.value = false
  }
  const playVideo = () => {
    videoState.isPlaying.value = true
  }
  const stopVideo = () => {
    videoState.isPlaying.value = false
  }
  const resetVideoNav = () => {
    videoState.isShowVideoNav.value = true
  }
  const hideVideoNav = () => {
    videoState.isShowVideoNav.value = false
  }
  const resetPause = () => {
    videoState.isPause.value = false
  }
  const setPause = () => {
    videoState.isPause.value = true
  }
  const checkVideoNav = () => {
    const videoElm = document.querySelector('.goods-detail-wrap .goods-detail-img')
    const infoTabElm = document.querySelector('.goods-detail-wrap .goods-detail-info-wrap')
    if (!videoElm || !infoTabElm) return
    const scrollY = window.scrollY
    const checkVideoArea = videoElm.getBoundingClientRect().top + videoElm.getBoundingClientRect().height
    const checkStickyArea = window.pageYOffset + infoTabElm.getBoundingClientRect().top

    // VideoArea 유무 check
    if (checkVideoArea < 0) {
      videoState.isVideoArea.value = false
    } else {
      videoState.isVideoArea.value = true
    }

    // info tab 스티키 position check
    if (checkStickyArea < scrollY) {
      uiLayoutStore.setHeaderClass('is-sticky')
    } else {
      uiLayoutStore.resetHeaderClass()
    }
  }

  const isAutoVideo = ref<boolean>(false)

  const autoPlayAllowed = (wifi: boolean) => {
    const allowedVideoSetting = webOrNativeLocalStorage.getItem(STORAGE_KEYS.LOCAL.ALLOWED_VIDEO_SETTING)
    isAutoVideo.value = false
    if (allowedVideoSetting === 'always') {
      isAutoVideo.value = true
    } else if (allowedVideoSetting === 'onlyWify' && wifi) {
      isAutoVideo.value = true
    } else {
      isAutoVideo.value = false
    }
  }

  async function checkWifi() {
    if (isNativeApp.value) {
      return new Promise<void>(function (resolve) {
        let wifi = false
        window[NATIVE_CALL_BACK.callbackIsWifiConnected] = function (nativeResult: string) {
          const result = JSON.parse(nativeResult)
          if (result.type === 'wifi') {
            wifi = true
          }
          autoPlayAllowed(wifi)
          resolve()
        }
        const payload = {
          command: NATIVE_MATHOD.isWifiConnected,
          parameters: {}
        }
        callBridgeNative(payload)
      })
    }
  }

  return {
    ...videoState,
    isAutoVideo,
    showVideo,
    hideVideo,
    playVideo,
    stopVideo,
    resetVideoNav,
    hideVideoNav,
    resetPause,
    setPause,
    checkVideoNav,
    autoPlayAllowed,
    checkWifi
  }
}
